/*
 * *****************************************************************************
 *     Copyright (C)  Motorola Solutions, INC.
 *     All Rights Reserved.
 *     Motorola Solutions Confidential Restricted.
 * *****************************************************************************
 */

import { AgentStatus } from 'CalltakingCoreApi';
import { RequestedAgentStatus } from '../model/requested-agent-status';

export class AcdFunctions {

    public static computeStatus(requestedStatus: RequestedAgentStatus, agentStatus: AgentStatus, phoneRegistered: boolean, hasRingingAssignedCall: boolean, hasAbandonedAssignedCall: boolean, anyActiveNonAcdCalls: boolean, anyHeldNonIgnoredCalls: boolean, anyActiveAcdCalls: boolean, pendingWrapUp: boolean, hasAcknowledgedAbandonedCall: boolean, hasRepresentedCallAssigned: boolean, primaryCtc: string): RequestedAgentStatus {
        if (!phoneRegistered) {
            return { status: 'PHONE_UNAVAILABLE', isAgentRequested: false, clusterName: primaryCtc };
        }
        if (anyActiveAcdCalls) {
            return { status: 'ON_ACD_CALL', isAgentRequested: false, clusterName: primaryCtc };
        }
        if (requestedStatus.status === 'READY' && hasRingingAssignedCall || hasRepresentedCallAssigned) {
            return { status: 'ASSIGNED_CALL', isAgentRequested: false, clusterName: primaryCtc };
        }
        if (requestedStatus.status === 'READY' && (hasAbandonedAssignedCall || hasAcknowledgedAbandonedCall)) {
            return { status: 'ASSIGNED_ABANDONED_CALL', isAgentRequested: false, clusterName: primaryCtc };
        }
        if (anyActiveNonAcdCalls) {
            return { status: 'ON_CALL', isAgentRequested: false, clusterName: primaryCtc };
        }
        if (anyHeldNonIgnoredCalls) {
            return { status: 'HOLDING_CALL', isAgentRequested: false, clusterName: primaryCtc };
        }
        if (requestedStatus.status === 'READY' && agentStatus === 'ON_ACD_CALL' && pendingWrapUp) {
            return { status: 'WRAPUP', isAgentRequested: false, clusterName: primaryCtc };
        }
        return { ... requestedStatus, clusterName: primaryCtc };
    }

    public static isBusy(status: AgentStatus) {
        switch (status) {
        case "ON_CALL":
        case "ON_ACD_CALL":
        case "HOLDING_CALL":
        case "WRAPUP":
            return true;
        default:
            return false;
        }
    }

    public static isReady(status: AgentStatus) {
        switch (status) {
        case "READY":
        case "ASSIGNED_CALL":
        case "ASSIGNED_ABANDONED_CALL":
            return true;
        default:
            return false;
        }
    }

    public static isNotReady(status: AgentStatus) {
        return status === 'NOT_READY';
    }

    public static isUnavailable(status: AgentStatus) {
        switch (status) {
            case "UNKNOWN":
            case "PHONE_UNAVAILABLE":
                return true;
            default:
                return false;
        }
    }

    public static isOnCall(status: AgentStatus) {
        switch (status) {
        case "ON_CALL":
        case "ON_ACD_CALL":
            return true;
        default:
            return false;
        }
    }
}
